import fp from 'lodash/fp';
import React from 'react';
import { Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { routes } from '../../../../constants';
import { getDueDateText } from '../../../../services';
import { Icon, SortableTable } from '../../../components';

const columns = [
  {
    name: 'name',
    display: () => 'Name',
    className: () => "name",
  },
  {
    name: 'description',
    display: () => 'Description',
    className: () => "description",
  },
  {
    name: 'dueDate',
    display: () => 'Due Date',
    className: () => "dueDate",
  },
  {
    name: 'options',
    display: () => '',
    className: () => "options",
  }
];

const PendingTasksTable = ({ tasks }) => {
  const rows = fp.map(
    ({ id, name, description, dueDate }) => {
      const { dueDateText, pastDue } = getDueDateText(dueDate)
      return {
        name: <LinkContainer className='no-padding' to={routes.app.tasks.view(id)}>
          <Button bsStyle='plain'>{name}</Button>
        </LinkContainer>,
        description,
        dueDate: <span className={pastDue ? 'pastDue' : ''}>{dueDateText}</span>,
        options: <LinkContainer className='view-pending-task' to={routes.app.tasks.view(id)}>
          <Icon icon='chevron-right-large' />
        </LinkContainer>
      }
    }
  )(tasks)
  return <div className='pending-tasks-table'>
    <SortableTable rows={rows} columns={columns} />
  </div>
}

export default PendingTasksTable


// WEBPACK FOOTER //
// ./src/containers/pages/app/dashboard/pending-tasks-table.js